export const swrOptions = {
    revalidateOnFocus: false,
};
export const swrFetcher = (url: string, controller?: AbortController) => fetch(url, {
    signal: controller?.signal,
    next: { revalidate: 10 }
} as RequestInit).then((res) => res.json());

